import { Suspense, lazy } from 'react'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ShieldCheck } from 'lucide-react'

// Top-level, no auth guard and no app shell — the patient is an anonymous, time-boxed party,
// not a signed-in WorkOS user (same posture as the dashboard's /r/$linkToken report-access route).
const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    )

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <div className="bg-background text-foreground flex min-h-[100dvh] flex-col items-center px-4 py-6 sm:py-10">
      <div className="flex w-full max-w-md flex-col">
        <div className="mb-3 flex items-center justify-between gap-2 px-1">
          <img src="/logo.avif" alt="SurveyHealth" className="h-6 dark:hidden" />
          <img src="/logo_dark.avif" alt="SurveyHealth" className="hidden h-6 dark:block" />
          <span className="text-muted-foreground flex items-center gap-1.5 text-xs font-semibold tracking-wide">
            <ShieldCheck className="size-3.5" />
            Secure consent
          </span>
        </div>

        <Outlet />

        <p className="text-muted-foreground/80 mt-4 px-1 text-center text-xs leading-relaxed">
          This is a private, encrypted page. Your information is used only to record your consent.
        </p>
      </div>

      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </div>
  )
}
